import { useCancelAssessmentProgress } from "@/api/console/companies/useCancelAssessmentProgress";
import { useStartAssessmentProgress } from "@/api/console/companies/useStartAssessmentProgress";
import DropdownButton from "@/components/DropdownButton";
import { STATUS } from "@/config/progress";
import toast from "@/lib/toast";
import { Company } from "@/schema/console/companies/Company";
import useCompanyDialog from "@/src/console/(auth)/companies/_hooks/useCompanyDialog";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { mutate } from "swr";

interface CompanyTableRowActionsProps {
  company: Company;
}

function CompanyTableRowActions({ company }: CompanyTableRowActionsProps) {
  const { t } = useTranslation();

  const NOT_UPDATABLE_STATUSES = [
    STATUS.NOT_STARTED,
    STATUS.ANSWERING,
    STATUS.SUBMITTED,
    STATUS.CERTIFICATED_ISSUED,
    STATUS.CANCELLED,
  ];

  const isNotStatusUpdatable = NOT_UPDATABLE_STATUSES.includes(
    company.status.id,
  );

  const { setDialog } = useCompanyDialog();
  const navigate = useNavigate();
  const { trigger: createAssessment } = useStartAssessmentProgress(company.id, {
    onSuccess: (data) => {
      mutate("/console/companies");
      toast.success(data.message);
    },
  });

  const { trigger: cancelAssessment } = useCancelAssessmentProgress(
    company.id,
    {
      onSuccess: (data) => {
        mutate("/console/companies");
        toast.success(data.message);
      },
    },
  );

  return (
    <DropdownButton
      items={[
        {
          item: t("view"),
          key: "view",
          onClick: () => navigate(`/console/companies/${company.id}`),
        },
        {
          item: t("start-new-assessment"),
          key: "start",
          onClick: () => {
            toast.loading(t("start-assessment-loading"));
            createAssessment();
          },
        },
        {
          hide: isNotStatusUpdatable,
          item: t("update-status"),
          key: "update-status",
          onClick: () =>
            setDialog({
              company,
              type: "update-status",
            }),
        },
        {
          item: t("update-assessment-date"),
          key: "update-assessment-date",
          onClick: () =>
            setDialog({
              company,
              type: "update-assessment-date",
            }),
        },
        {
          item: <span className="text-red-500">{t("cancel-assessment")}</span>,
          key: "cancel",
          onClick: () => {
            toast.loading(t("cancel-assessment-loading"));
            cancelAssessment();
          },
        },
      ]}
    />
  );
}

export default CompanyTableRowActions;
